export default __webpack_public_path__ + "static/media/no_smoke.13d91b6c.png";